import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=b494d9d8"
import script from "./AddDialog.vue?vue&type=script&lang=js"
export * from "./AddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports